import {
    REQUEST_LOGIN,
    REQUEST_SIGNUP,
    SET_IS_AUTHORIZED,
    SET_PASSWORD_CHANGED,
    REQUEST_LOGIN_OR_SIGNUP_SUCCESS,
    REQUEST_LOGIN_OR_SIGNUP_FAILURE,
    REQUEST_CHANGE_PASSWORD,
    SIGN_OUT
} from './constants'

const initialState = {
    isAuthorized: false,
    loading: {
        auth: false,
        changePassword: false
    },
    me: {
        jwt: ''
    }
}

const reducer = (state = initialState, { type, payload, error }) => {
    switch (type) {
        case REQUEST_LOGIN:
        case REQUEST_SIGNUP:
            return {
                ...state,
                loading: {
                    ...state.loading,
                    auth: true
                }
            }
        case SET_IS_AUTHORIZED:
            return {
                ...state,
                isAuthorized: payload
            }
        case REQUEST_LOGIN_OR_SIGNUP_SUCCESS:
            return {
                ...state,
                me: {
                    ...payload.admin,
                    jwt: payload.jwt
                },
                loading: {
                    ...state.loading,
                    auth: false
                }
            }
        case REQUEST_LOGIN_OR_SIGNUP_FAILURE:
            return {
                ...state,
                loading: {
                    ...state.loading,
                    auth: false
                }
            }
        case SIGN_OUT:
            return {
                ...state,
                isAuthorized: false,
                me: {
                    ...initialState.me
                }
            }
        case REQUEST_CHANGE_PASSWORD:
            return {
                ...state,
                loading: {
                    ...state.loading,
                    changePassword: true
                }
            }
        case SET_PASSWORD_CHANGED:
            return {
                ...state,
                loading: {
                    ...state.loading,
                    changePassword: false
                }
            }
        default:
            return state
    }
}

export default reducer
